// extracted by mini-css-extract-plugin
module.exports = {"container":"e_TG","tab":"e_UG","current":"e_VG"};